var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hackathon"}},[_c('div',{staticClass:"timer"},[_c('h1',[_vm._v("Sıradaki Hackathon'a kalan süre")]),_c('flip-countdown',{attrs:{"deadline":"2021-01-02 10:00:00"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }